import moment from 'moment';
import type { IntlShape } from 'react-intl';

import type { ReportGroupBy } from '../types';

/** Short axis label for a period start date, according to the report grouping. */
export const formatPeriodLabel = (date: string, groupBy: ReportGroupBy, intl: IntlShape): string => {
  const value = moment(date);

  switch (groupBy) {
    case 'week':
      return intl.formatMessage(
        { id: 'dashboards.schedules.summary.period.week' },
        { week: value.isoWeek() },
      );
    case 'month':
      return intl.formatDate(value.toDate(), { month: 'short', year: 'numeric' });
    case 'quarter':
      return intl.formatMessage(
        { id: 'dashboards.schedules.summary.period.quarter' },
        { quarter: value.quarter(), year: value.year() },
      );
    case 'year':
      return intl.formatDate(value.toDate(), { year: 'numeric' });
    default:
      return intl.formatDate(value.toDate(), { weekday: 'short', day: 'numeric' });
  }
};
